import styled from 'styled-components';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const InsightsList = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    gap: 8px;
    min-width: 0;
`;

export const InsightGroup = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
`;

export const InsightLink = styled.button<{ theme: InterstateTheme }>`
    padding: 0;
    border: 0;
    background: none;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    color: ${({ theme }) => theme.tokens.BaseColorBlue700};
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.tokens.BaseColorBlue700};
        outline-offset: 2px;
    }
`;

export const InsightSeparator = styled.span<{ theme: InterstateTheme }>`
    flex: 0 0 1px;
    height: 18px;
    background-color: ${({ theme }) => theme.tokens.BaseColorGray200};
`;

export const InsightLoading = styled.span`
    overflow: hidden;
    min-width: 0;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
